import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

const TuneOutlinedIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6H14M21 6H16M16 3V9M3 12H8M8 9V15M10 12H21M3 18H10M12 15V18M12 21V18M21 18H12" stroke="currentColor"/>
    </svg>
)
const TuneOutlinedIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {TuneOutlinedIconSvg}
    </SvgIcon>
);
export default TuneOutlinedIcon